module.exports = __webpack_public_path__ + "img/creditkarma.cbc025cf.png";